import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { ChatPluginFunction } from './chatPluginFunctionTypes';
import {
  generateFilterExpression,
  FilterParameters,
} from 'utilities/hooks/urlGeneration';

interface ChatPluginFunctionsResponse {
  data: ChatPluginFunction[];
  included?: any[];
}

type QueryOptions = {
  enabled?: boolean;
};

export const useChatPluginFunctions = (
  chatID: string,
  options: QueryOptions = {}
) => {
  const getChatPluginFunctions = () => {
    const filters: FilterParameters[] = [
      {
        key: 'chatID',
        value: chatID,
        type: 'equal',
      },
      {
        key: 'isDeleted',
        value: false,
        type: 'equal',
      },
    ];

    const queryArray = [generateFilterExpression('and', filters)];

    const url = generateURL(SPARK_RESOURCE_TYPES.CHAT_PLUGIN_FUNCTIONS, []);

    return fetchWrapper<ChatPluginFunctionsResponse>({
      url,
      method: 'GET',
    });
  };

  return useQuery<ChatPluginFunctionsResponse, Error>(
    [SPARK_RESOURCE_TYPES.CHAT_PLUGIN_FUNCTIONS, chatID],
    getChatPluginFunctions,
    {
      ...options,
      onError: (error) => {
        console.error('Error fetching chat plugin functions:', error);
      },
    }
  );
};
